import isDeleting from "./isDeleting";
import isDeleted from "./isDeleted";

export default ({ itemState }) =>
  isDeleting({ itemState }) || isDeleted({ itemState });
